// Components==============
import React from 'react';
import { DownloadButton } from '../DownloadButton';
import './index.module.scss';
// =========================

const Image = ({ item }) => (
    <img src={`/storage/${item}`} styleName="image" alt="item" />
);
const ImageWithText = ({ item }) => (
    <div styleName="image-with-text">
        <div styleName="left">
            <img src={`/storage/${item?.image}`} alt="item" />
            <p styleName="caption">{item?.caption}</p>
        </div>
        <p style={{ backgroundColor: item?.color }} styleName="text">
            {item?.text}
        </p>
    </div>
);
const Text = ({ item }) => (
    <div dangerouslySetInnerHTML={{ __html: item }} styleName="richText" />
);

const NewsText = ({ item }) => (
    <div dangerouslySetInnerHTML={{ __html: item }} styleName="newsText" />
);
const Title = ({ item }) => <h3 styleName="title">{item}</h3>;
const Video = ({ item }) => (
    <>
        {item.video_type && (
            <div
                style={
                    item.video_type === 'vimeo'
                        ? { paddingBottom: '56%' }
                        : null
                }
                styleName="aspect-r"
            >
                {item.video_type === 'youtube' && (
                    <iframe
                        style={{ width: '100%', height: '100%' }}
                        src={`https://www.youtube.com/embed/${item.video_id}`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="youtube"
                    />
                )}
                {item.video_type === 'vimeo' && (
                    <iframe
                        src={`https://player.vimeo.com/video/${item.video_id}`}
                        style={{ width: '100%', height: '100%' }}
                        frameBorder="0"
                        allow="autoplay; fullscreen"
                        allowFullScreen
                        title="vimeo"
                    />
                )}
            </div>
        )}
    </>
);

export default function RichText({ richText, description }) {
    return richText?.map((e, i) => {
        const { layout, attributes } = e;

        const mutatedText = attributes?.text?.replace(
            /<a /g,
            '<a target="_blank" rel="noreferrer" '
        );

        if (description === true && layout === 'text') {
            return (
                <NewsText
                    key={i}
                    item={attributes.text.slice(
                        attributes.text.indexOf('<p>'),
                        attributes.text.indexOf('</p>')
                    )}
                />
            );
        }

        if (!description) {
            if (layout === 'image') {
                return <Image key={i} item={attributes.image} />;
            }
            if (layout === 'image_with_text') {
                return <ImageWithText key={i} item={attributes} />;
            }
            if (layout === 'text') {
                return <Text key={i} item={mutatedText} />;
            }
            if (layout === 'title') {
                return <Title key={i} item={attributes.title} />;
            }
            if (layout === 'video') {
                return <Video item={attributes} key={i} />;
            }
            if (layout === 'file') {
                return (
                    <DownloadButton
                        file={`/storage/${attributes?.file}`}
                        key={i}
                        text={attributes?.file}
                    />
                );
            }
        }

        return <React.Fragment key={i} />;
    });
}
